import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ZStoreService {
  public zToolEntityDrag$ = new Observable<number>();
  private zToolEntityDragSubject = new BehaviorSubject<number>(10);
  public whichDraging = { ring: false, line: false, crossline: false};
  constructor() {
    this.zToolEntityDrag$ = this.zToolEntityDragSubject.asObservable();
  }

  zIncrease() {
    this.zToolEntityDragSubject.next(100);
  }
  zDecrease() {
    this.zToolEntityDragSubject.next(-100);
  }
}
